import { Grid2 } from "@mui/material";
import React from "react";
import AnalyticsBox from "../Common/AnalyticsBox";

const AnalyticsCard = () => {
  return (
    <Grid2 container spacing={2} sx={{ mt: 2 }}>
      <AnalyticsBox
        title="Active Subscriptions"
        number="543.4K"
        per="/mo"
        small
        tboxes
      />
      <AnalyticsBox
        title="Current Month Payment Received"
        number="543.4K"
        per="/mo"
        small
        tboxes
      />
      <AnalyticsBox
        title="last Month Payment ReceiveD"
        number="500K"
        per="/mo"
        small
        tboxes
      />
    </Grid2>
  );
};

export default AnalyticsCard;
